<template>
    <div class="refresh" @click="clickRefresh"> 
        <div :class="{active: isActive}" ><img src="../../assets/images/public/refresh.png"></div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
export default defineComponent({
    emits: ['pageRefresh'],
    props: {
        isActive: {
            type: Boolean,
            default: false
        }
    },
    setup(_,context){
       let clickRefresh = () => {
        console.log(_)
        context.emit('pageRefresh')
       }
    return {
        clickRefresh
    }

    }
})
</script>

<style lang="scss" scoped>
    .active{
        transform: rotate(360deg);
    }

</style>